import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { connect } from 'react-redux';

import {
  EDIT_PROFILE_URL,
  MODALS,
  DASHBOARD_URL,
  ANALYTICS_URL,
  TENDERS_LIST_URL,
  JOB_LIST_URL,
  INFLUENCER_PREVIEW_URL
} from 'global-constants';

import WithPush from 'shared/HOCs/WithPush';
import WithUser from 'shared/HOCs/WithUser';

import logout from 'shared/utils/logout';
import { userHasPlan } from 'shared/utils/userPlanCheck';
import { substituteUrl } from 'shared/utils/substituteUrl';
import { getInfluencerFullName } from 'shared/utils/influencer';
import { calculateProfileStrengthPercentage } from 'shared/utils/profileProgress';

import Divider from 'shared/components/Divider';
import Button from 'shared/components/Button';
import { openModal } from 'shared/components/Modals/reducer';
import ProgressBar from 'shared/components/PercentageProgressBar';
import Link from 'shared/components/Navigation/MobileNav/IconLink';
import { PLAN_TYPES } from 'shared/components/ChangePlanModal/constants';
import InfluencerOccupationWithLink from 'shared/components/InfluencerOccupationWithLink';

import { setActiveTab, EDIT_PROFILE_TABS } from 'pages/EditProfile/ducks';

import logout_image from 'assets/images/profile/logout.svg';
import subscription from 'assets/images/profile/subscription.svg';
import preferences from 'assets/images/profile/preferences.svg';
import edit_profile from 'assets/images/profile/edit-profile.svg';
import analytics from 'assets/images/profile/analytics.svg';
import feed from 'assets/images/profile/feed.svg';
import jobs from 'assets/images/profile/jobs.svg';
import tenders from 'assets/images/profile/tenders.svg';

import styles from './styles.module.scss';

class Profile extends React.Component {
  redirectToEditProfilePage = page => {
    const {
      push,
      setActiveTab,
      closeAction = () => {
        return;
      },
      closeNavigation = () => {
        return;
      }
    } = this.props;

    push(EDIT_PROFILE_URL);
    setActiveTab(page);
    closeAction();
    closeNavigation();
  };

  render() {
    if (_.isEmpty(this.props.user)) return '';

    const {
      user,
      push,
      openModal,
      visible,
      closeAction = () => {
        return;
      },
      closeNavigation = () => {
        return;
      }
    } = this.props;

    const percentage = calculateProfileStrengthPercentage(user);
    const isFreePlan = userHasPlan(user, PLAN_TYPES.FREE);

    return (
      <div
        className={classnames(styles.container, { [styles.visible]: visible })}>
        <div
          className={styles.names}
          onClick={() =>
            push(
              substituteUrl(INFLUENCER_PREVIEW_URL, {
                influencerSlug: user.slug
              })
            )
          }>
          {getInfluencerFullName(user)}
        </div>
        <div className={styles.occupation}>
          <InfluencerOccupationWithLink influencer={user} />
        </div>
        <div className={styles.analyticsInfo}>
          <div className={styles.data}>
            {user.contribution_count} Contributions
          </div>
          <div className={styles.data}>{user.connection_count} Connections</div>
        </div>
        <div className={styles.links}>
          <Divider className={styles.divider} />
          <Link
            alt="feed icon"
            img={feed}
            onClick={() => {
              push(DASHBOARD_URL);
              closeNavigation();
              closeAction();
            }}>
            Newsfeed
          </Link>
          <Link
            alt="analytics icon"
            img={analytics}
            onClick={() => {
              push(ANALYTICS_URL);
              closeNavigation();
              closeAction();
            }}>
            Analytics
          </Link>
          <Link
            alt="tenders icon"
            img={tenders}
            onClick={() => {
              push(substituteUrl(TENDERS_LIST_URL, { activeTab: 'open' }));
              closeNavigation();
              closeAction();
            }}>
            Projects
          </Link>
          {_.get(user, 'is_superuser') && (
            <Link
              alt="jobs icon"
              img={jobs}
              onClick={() => {
                push(JOB_LIST_URL);
                closeNavigation();
                closeAction();
              }}>
              Jobs
            </Link>
          )}

          <Divider className={styles.divider} />
          <Link
            alt="profile icon"
            img={edit_profile}
            onClick={() =>
              this.redirectToEditProfilePage(EDIT_PROFILE_TABS.PROFILE)
            }>
            Edit Profile
          </Link>
          <Link
            alt="preferences icon"
            img={preferences}
            onClick={() =>
              this.redirectToEditProfilePage(EDIT_PROFILE_TABS.PREFERENCES)
            }>
            Preferences
          </Link>
          <Link
            alt="credit card icon"
            img={subscription}
            onClick={() => {
              push(EDIT_PROFILE_URL);
              openModal({ modalName: MODALS.CHANGE_PLAN });
              closeNavigation();
              closeAction();
            }}>
            Subscription
          </Link>
          <Divider className={classnames(styles.divider, styles.hideSm)} />
          {percentage.toString() !== '100' && (
            <div className={styles.progress}>
              <ProgressBar percentage={percentage} title="Profile Strength" />
              <Divider className={classnames(styles.divider, styles.hideSm)} />
            </div>
          )}
          <div className={styles.bottom}>
            {isFreePlan && (
              <Button
                className={styles.upgradePlan}
                color="brand-green"
                onClick={() =>
                  openModal({
                    modalName: MODALS.CHANGE_PLAN
                  })
                }
                type="submit">
                Upgrade Plan
              </Button>
            )}
            {user.is_superuser && (
              <Link
                className={styles.massMessaging}
                icon="mail_outline"
                onClick={() =>
                  this.props.openModal({
                    modalName: MODALS.SEND_MESSAGES_MODAL
                  })
                }>
                Send mass message
              </Link>
            )}
            <Link
              alt="logout icon"
              img={logout_image}
              className={styles.red}
              onClick={logout}>
              Logout
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default WithPush(
  WithUser(
    connect(
      null,
      { openModal, setActiveTab }
    )(Profile)
  )
);
